<h1 [ngClass]="titleWidget?.class">
  {{ getTitle() | i18n }} {{ getSubtitle() }}
</h1>
